export enum PaymentMode {
  CASH = "Cash",
  BANK_TRANSFER = "Net Banking",
  UPI = "UPI",
  CHEQUE = "Cheque",
  OTHER = "Other",
}

export type InstallmentPaymentValues = {
  installmentAmount: string;
  date: any | null;
  paymentRemark: string;
  netReceivedAmount: string ;
  paymentMode: { label: string; value: keyof typeof PaymentMode };
  account: any;
  couponCode: any;
  couponData: {
    couponCode: string;
    discountAmount: string;
    discountType: "FIXED" | "PERCENTAGE";
    maxDiscountAmount: string;
  } | null;
};
